module.exports = __webpack_public_path__ + "static/media/docks_1.138aab05.png";